module.exports = __webpack_public_path__ + "static/media/156662819939lzR3gB2i.f14721a5.png";